import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { Link as Link$2, IconBefore, LinkText, IconAfter } from './Link.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "href", "onClick", "iconBefore", "iconAfter", "ariaExpanded", "ariaLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Link = function Link(_ref) {
  var children = _ref.children,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? null : _ref$href,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$iconBefore = _ref.iconBefore,
    iconBefore = _ref$iconBefore === void 0 ? null : _ref$iconBefore,
    _ref$iconAfter = _ref.iconAfter,
    iconAfter = _ref$iconAfter === void 0 ? null : _ref$iconAfter,
    _ref$ariaExpanded = _ref.ariaExpanded,
    ariaExpanded = _ref$ariaExpanded === void 0 ? null : _ref$ariaExpanded,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? null : _ref$ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!children) {
    return false;
  }
  var missingOnClickAndUrl = typeof onClick !== 'function' && !href;
  var renderType = href ? 'a' : 'button';
  if (missingOnClickAndUrl) {
    renderType = 'div';
  }
  var hasIcon = iconBefore || iconAfter;
  return /*#__PURE__*/jsxs(Link$2, _objectSpread(_objectSpread({
    onClick: onClick,
    type: renderType === 'button' ? 'button' : null,
    as: renderType,
    href: href,
    "aria-expanded": ariaExpanded,
    "aria-label": ariaLabel || (typeof children === 'string' ? children : undefined)
  }, rest), {}, {
    children: [/*#__PURE__*/React.isValidElement(iconBefore) && /*#__PURE__*/jsx(IconBefore, {
      children: /*#__PURE__*/React.cloneElement(iconBefore, {
        size: 'xxs'
      })
    }), /*#__PURE__*/jsx(LinkText, {
      // @ts-ignore
      $hasIcon: hasIcon,
      children: children
    }), /*#__PURE__*/React.isValidElement(iconAfter) && /*#__PURE__*/jsx(IconAfter, {
      children: /*#__PURE__*/React.cloneElement(iconAfter, {
        size: 'xxs'
      })
    })]
  }));
};
var Link$1 = Link;

export { Link$1 as default };
//# sourceMappingURL=Link.js.map
